import { CaseMilestone } from '../../data/types';
import { useAppDispatch } from '../hooks';
import { addOrReplaceCaseMilestoneAction, deleteCaseMilestonesAction, deleteCaseMilestoneAction, setCaseMilestonesAction } from '../reducers/caseMilestoneReducer';

export const useCaseMilestoneActions = () => {

    const dispatch = useAppDispatch();

    const addOrReplaceCaseMilestone = (milestone: CaseMilestone) => {
        dispatch(addOrReplaceCaseMilestoneAction(milestone));
    }

    const setCaseMilestones = (milestones: CaseMilestone[]) => {
        dispatch(setCaseMilestonesAction(milestones));
    }

    const removeCaseMilestone = (milestoneId: string) => {
        dispatch(deleteCaseMilestoneAction(milestoneId));
    }

    const removeCaseMilestones = (milestoneIds: string[]) => {
        dispatch(deleteCaseMilestonesAction(milestoneIds));
    }

    return { addOrReplaceCaseMilestone, setCaseMilestones, removeCaseMilestone, removeCaseMilestones };
}
